import * as p2 from 'p2-es'
import appConfig from '../../data/appConfig'
import { getLatestState, updateState } from '../gameState'
import spritePool from '../spritePool'
import { Point } from 'pixi.js'
import { sounds } from './sound'
import assHeadBodies from '../../assets/generated/ass-head.json'
import getLevelOffsetBasedOnCurrentLevel from '../helpers/getLevelOffsetBasedOnCurrentLevel'
import { spawnSprite } from './levelEditor'
export const worlds = Object.keys(assHeadBodies)
	.filter(key => key.includes('world'))
	.map(key => assHeadBodies[key as keyof typeof assHeadBodies])

export const world = new p2.World({
	gravity: [0, 1000],
})
export const walrusMaterial = new p2.Material()
export const worldMaterial = new p2.Material()
const walrusWorldContactMaterial = new p2.ContactMaterial(worldMaterial, walrusMaterial, {
	friction: 1e10,
	restitution: 0,
	stiffness: 1e9,
	surfaceVelocity: 0,
})

world.addContactMaterial(walrusWorldContactMaterial)

const xLimit = appConfig.level.xLimit

const getAnchorPointFromIndex = (i: number): Point => {
	return new Point(
		(i % xLimit) * appConfig.width + appConfig.width * 0.5,
		-Math.floor(i / xLimit) * appConfig.height + appConfig.height * 0.5,
	)
}
const getOffsetFromIndex = (i: number): Point => {
	return new Point((i % xLimit) * appConfig.width + appConfig.width, -Math.floor(i / xLimit) * appConfig.height + appConfig.height)
}
const createWalrus = (world: p2.World): p2.Body => {
	//create a p2 circle
	const circleShape = new p2.Circle({ radius: 48, material: walrusMaterial })
	const walrusBody = new p2.Body({
		mass: 10,
		position: [100, 150],
	})

	walrusBody.addShape(circleShape)

	world.addBody(walrusBody)

	return walrusBody
}

const createWorldBodies = (world: p2.World): p2.Body[] => {
	let bodies: p2.Body[] = []
	Object.keys(worlds).forEach((key, i) => {
		const offset = getAnchorPointFromIndex(i)
		const vertices = worlds[key as keyof typeof worlds] as number[][][]
		const body = new p2.Body({
			mass: 0,
			position: [offset.x, offset.y],
		})
		vertices.forEach(verts => {
			body.addShape(new p2.Convex({ vertices: verts, material: worldMaterial }))
		})

		bodies.push(body)
		world.addBody(body)
	})

	return bodies
}

// create debugger canvas and level editor menu
const [canvas, ctx] = (() => {
	const div = document.createElement('div')
	div.classList.add('walrus-debugger')
	const canvas = document.createElement('canvas')
	
	// Level editor menu
	const levelEditorMenu = document.createElement('div')
	levelEditorMenu.id = "level-editor-menu";
	levelEditorMenu.classList.add('level-editor-menu', 'd-none')
	Object.keys(spritePool.obstacleSprites).forEach(key => {
		const button = document.createElement('button')
		button.classList.add('level-editor-menu-element')
		button.innerHTML = key
		button.addEventListener('click', e => spawnSprite(e))
		levelEditorMenu.appendChild(button)
	})

	document.body.appendChild(levelEditorMenu)
	div.appendChild(canvas)
	document.body.appendChild(div)
	const ctx = canvas.getContext('2d')

	if (!ctx) throw new Error('Could not get 2d context')

	canvas.width = appConfig.width
	canvas.height = appConfig.height

	return [canvas, ctx]
})()

const worldBodies = createWorldBodies(world)
export const walrusBody = createWalrus(world)

const fixedTimeStep = 1 / 60 // seconds
const maxSubSteps = 10 // Max sub steps to catch up with the wall clock

world.on('beginContact', (event: p2.BeginContactEvent) => {
	if (event.bodyA === walrusBody || event.bodyB === walrusBody) {
		let { player, screenShakeIntensity } = getLatestState()
		if (walrusBody.velocity[1] > 300) {
			screenShakeIntensity += appConfig.screenShakeIntensity
			const dustEmitter = spritePool.dustEmitter
			if (dustEmitter) {
				dustEmitter.spawnPos = new Point(walrusBody.position[0], walrusBody.position[1] + 25)
				dustEmitter.emit = true
			}
			sounds.land()
		}
		updateState({ player: { ...player, isGrounded: true }, screenShakeIntensity })
	}
})

world.on('endContact', (event: p2.EndContactEvent) => {
	if (event.bodyA === walrusBody || event.bodyB === walrusBody) {
		// const { player } = getLatestState()
		// updateState({ player: { ...player, isGrounded: false } })
	}
})

const renderDebug = (body: p2.Body, strokeStyle: string | CanvasGradient | CanvasPattern = 'blue') => {
	const [offsetX, offsetY] = getLevelOffsetBasedOnCurrentLevel()
	for (let i = 0; i < body.shapes.length; i++) {
		const {
			position: [pX, pY],
		} = body
		const shape = body.shapes[i]
		if (shape instanceof p2.Circle) {
			const { radius } = shape
			ctx.beginPath()
			ctx.arc(offsetX + pX, offsetY + pY, radius, 0, 2 * Math.PI)
			ctx.closePath()
		}
		if (shape instanceof p2.Convex) {
			ctx.beginPath()
			const { vertices } = shape
			ctx.moveTo(offsetX + pX + vertices[0][0], offsetY + pY + vertices[0][1])
			for (let j = 1; j < vertices.length; j++) {
				ctx.lineTo(offsetX + pX + vertices[j][0], offsetY + pY + vertices[j][1])
			}
			ctx.closePath()
		}
	}

	// Customize the rendering style (fill and stroke)
	ctx.strokeStyle = strokeStyle
	ctx.lineWidth = 4
	ctx.stroke()
}

// Animation loop
function updateP2(deltaTime: number) {
	// Clear the canvas
	ctx.clearRect(0, 0, canvas.width, canvas.height)

	// Move bodies forward in time
	world.step(fixedTimeStep, deltaTime / 60, maxSubSteps)
	if (process.env.NODE_ENV !== 'production') {
		renderDebug(walrusBody, 'red')
		worldBodies.forEach(body => {
			renderDebug(body)
		})
	}
}

export default updateP2
